<template>
  <div :class="[$style.titleLine, ...classes_list]">
    <h1
      :class="[$style.title, 'text-h1']"
      v-if="!hide_title"
    >
      <slot name="title" />
    </h1>
    <slot name="title-outer" />
    <div
      v-if="!hide_btns"
      :class="$style.btns"
    >
      <slot
        v-if="canShowCustomBtn"
        name="custom-btn"
      />
      <v-btn
        v-else
        text
        @click="edit_btn_clicked"
        :disabled="disabled"
        :class="$style.editPartnerMobile"
      >
        <v-icon class="mr-2">mdi-pencil-outline</v-icon>
        <span>
          <slot name="edit-btn-text" />
        </span>
      </v-btn>
    </div>
    <slot name="inner" />
    <slot name="btn-outer" />
  </div>
</template>

<script lang="ts">
import {
  Component, Emit, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class PageTitle extends Vue {
  @Prop({ type: Boolean, default: false })
  hide_title!: boolean;

  @Prop({ type: Boolean, default: false })
  hide_btns!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  get canShowCustomBtn() {
    return !!this.$scopedSlots['custom-btn'];
  }

  @Prop({
    type: [
      String, Array,
    ],
    default: () => [],
  })
  classes!: string | [];

  get classes_list() {
    if (Array.isArray(this.classes)) {
      return this.classes;
    }
    return this.classes.split(' ');
  }

  @Emit()
  edit_btn_clicked() {
    return true;
  }
}
</script>

<style module lang="scss">
.titleLine {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.title {
  margin-right: 16px;
}

.btns {
  margin-right: auto;
}

@media (min-width: 600px) and (max-width: 959px) {
  .titleLine {
    flex-wrap: wrap;
    row-gap: 24px;
    justify-content: space-between;
  }
  .editPartnerMobile {
    padding-left: 0 !important;
  }
}

@media (max-width: 599px) {
  .titleLine {
    flex-wrap: wrap;
    row-gap: 24px;
    margin-left: 16px;
    justify-content: space-between;
  }

  .editPartnerMobile {
    padding-left: 0 !important;
  }

  .btns {
    display: flex;
    row-gap: 20px;
    flex-wrap: wrap;
  }
}

// .main-title{
//   margin-bottom: 0px;
// }
</style>
